module.exports = __webpack_public_path__ + "VIPV25.png?42362420cebe325fbdd873562211eb8c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV25.png
// module id = 120
// module chunks = 0